<div class="timer">
  <span id="days">
    <h3>Te quedan:</h3>
    {{ daysToDday }} </span
  >Dia(s) <span id="hours"> {{ hoursToDday }} </span>Hrs
  <span id="minutes"> {{ minutesToDday }} </span>Mins.
  <h4>De tu periodo de prueba.</h4>
</div>
